const LAST_RELOAD_KEY = 'staleChunkReloadAt';
const RELOAD_WINDOW_MS = 60_000;

let reloading = false;

// Claims the one reload allowed per window. Without readable storage there is no loop guard, so
// it declines and lets the error surface rather than risk reloading forever.
function claimReload(storage: Storage | undefined, now: number): boolean {
  try {
    storage ??= window.sessionStorage;
    const lastReload = Number(storage.getItem(LAST_RELOAD_KEY));
    if (lastReload && now - lastReload < RELOAD_WINDOW_MS) {
      return false;
    }
    storage.setItem(LAST_RELOAD_KEY, String(now));
    return true;
  } catch {
    return false;
  }
}

/**
 * Handles Vite's `vite:preloadError`, raised when a lazily imported chunk fails to load.
 *
 * A deploy replaces the hashed chunks an already-open tab still references, so the first
 * failure reloads the page onto the new build instead of surfacing an error; sibling chunks
 * failing in the same page load are swallowed while that reload is pending. A failure inside
 * the window after a reload means the chunk is genuinely missing, and it is left to throw.
 */
export function ReloadOnceForStaleChunk(
  event: Event,
  storage?: Storage,
  reload: () => void = () => window.location.reload(),
  now: number = Date.now(),
): void {
  if (reloading) {
    event.preventDefault();
    return;
  }
  if (!claimReload(storage, now)) {
    return;
  }

  reloading = true;
  event.preventDefault();
  reload();
}

export function ResetStaleChunkReloadForTest(): void {
  reloading = false;
}
